import { createTheme } from '@mui/material/styles'

const LightTheme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#0046FF',
            contrastText: '#FFFFFF'
        },
        secondary: {
            main: '#607D8B',
            contrastText: '#FFFFFF'
        },
        background: {
            default: '#F4F4F4'
        },
        text: {
            primary: '#212121',
            secondary: '#757575'
        },
        cardIcon: {
            main: '#212121'
        },
        chart: {
            main: '#824ac3',
            min: '#C34A4E',
            average: '#0046FF',
            max: '#4AC3BF'
        }
    }
})

export default LightTheme